import React, { useContext, useState,useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
  formatPrice,
  pagination,
  showingData,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Moment from "react-moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import { MdDelete } from 'react-icons/md';
// import StockReport from "./StockReport";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { FinanceContext } from "../../../../../contexts/Finance";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const LedgerReport = () => {

  const { t } = useTranslation();
  let { generalSettings } = useContext(SettingsContext);
  const { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);

  //finance context
  const {
    loading,
    setLoading,
    cao3Active,
  } = useContext(FinanceContext);

  //toast obj
  let common_toast={
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  }

  //reportFields state
  const [reportFields,setReportFields]=useState({
    from_date:"",
    to_date:"",
    account:"",
    branch: ""
  });

  //report states
  const [reportData, setReportData] = useState([]);
  const [ledgerView, setLedgerView] = useState(null);
  const [searchLedgerView, setSearchLedgerView] = useState({
    searched: false,
    list: [],
  });
  const [ledgerSummary, setLedgerSummary] = useState({
    excel: false,
    data: null,
  });
  const isThrottled = useRef(false);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option,setOption] = useState("view");
  const [reportOption,setReportOption] = useState("detail");
  const [reportType,setReportType] = useState("with_zero");

  const componentRef = useRef();
  const componentRef1 = useRef();

  //search account here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchLedgerView({ ...searchLedgerView, searched: false });
    } else {
      let searchedList = ledgerView?.data && ledgerView.data.filter((item) => {          
        let lowerCaseItemIdentity = item.DocumentIdentity && item.DocumentIdentity.toLowerCase();
        let lowerCaseItemAccount = item.AccountName.toLowerCase();
        let lowerCaseItemCheque = item.ChequeNo && item.ChequeNo.toLowerCase();
        return (lowerCaseItemIdentity && lowerCaseItemIdentity.includes(searchInput)) ||
        (lowerCaseItemAccount && lowerCaseItemAccount.includes(searchInput)) ||
        (lowerCaseItemCheque && lowerCaseItemCheque.includes(searchInput));
      });
      setSearchLedgerView({
        list: searchedList,
        searched: true,
      });
    }
  };

  const handleOption  = (e) =>{
    setOption(e.target.value)
  }

  const handleReportOption  = (e) =>{
    setReportOption(e.target.value)
  }

  const handleReportType  = (e) =>{
    setReportType(e.target.value)
  }

  const handleFromDate=(from_date)=>{
    setReportFields({
      ...reportFields,
      from_date
    })
  }

  const handleToDate=(to_date)=>{
    setReportFields({
      ...reportFields,
      to_date
    })
  }

  const handleAccount=(account)=>{
    setReportFields({
      ...reportFields,
      account
    })
  }

  const handleBranch=(branch)=>{
    setReportFields({
      ...reportFields,
      branch
    })
  }

  const paginatedLedger = (page)=>{
    if (isThrottled.current) {
      return;
    }
    isThrottled.current = true;
    setTimeout(() => {
      isThrottled.current = false;
    }, 2500);
    setLoading(true);
    const url = BASE_URL + "/settings/get-ledger-report?page="+page;
    let {from_date , to_date ,account, branch} = reportFields
    let formData = new FormData();
    formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
    formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
    formData.append('coa_id', account ? account.id : "");
    formData.append('branch_id', branch ? branch.id : "");
    formData.append('type', reportType);
    return axios
    .post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    .then((res) => {
      setLedgerView(res.data[1]);
      setLoading(false);
    })
    .catch((error) => {            
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`,common_toast);
    });
  }

  const ledgerDetailReport = () =>{
    let { from_date, to_date, account, branch } = reportFields;
    if(option === "view"){
      paginatedLedger(1);
    }else{  
      setLoading(true);
      const endPoint = "/settings/get-ledger-report" ;
      const url = BASE_URL + endPoint;
      let formData = new FormData();
      formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
      formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
      formData.append('coa_id', account ? account.id : "");
      formData.append('branch_id', branch ? branch.id : "");
      formData.append('type', reportType);

      return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setReportData(res.data[0]);
        setGeneratedReport(true);
        componentRef.current.handleDownload();
        setLoading(false);
      })
      .catch((error) => {            
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`,common_toast);
      });
    }
  }

  const ledgerSummaryReport =()=>{
    let { from_date, to_date, account, branch } = reportFields
    const endPoint = "/settings/get-ledger-summary-report" ;
    const url = BASE_URL + endPoint;
    let formData = new FormData();
    formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
    formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
    formData.append('coa_id', account ? account.id : "");
    formData.append('branch_id', branch ? branch.id : "");
    formData.append('type', reportType);

    setLoading(true);
    return axios
    .post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    .then((res) => {
      if(option === "view"){
        setLedgerSummary({
          excel: false,
          data: res.data[0],
        })
      }else{
        setLedgerSummary({
          excel: true,
          data: res.data[0],
        })
        componentRef1.current.handleDownload();
      }
      setLoading(false);
    })
    .catch((error) => {            
      setLoading(false);
      toast.error(`${_t(t("Please try again"))}`,common_toast);
    });
  }

  const handleSubmit=(e)=>{
    e.preventDefault();
    setLedgerView(null);
    setSearchLedgerView({
      searched: false,
      list: [],
    });
    setLedgerSummary({
      excel: false,
      data: null,
    })
    let { from_date, to_date, account, branch } = reportFields;
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !branch?.id
    ) {
      toast.error(`${_t(t("Please select branch"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if((from_date !== "" && from_date !== null) && (to_date !== "" && to_date !== null) && account){
      if(reportOption === "detail"){
        ledgerDetailReport();
      }else{
        ledgerSummaryReport();
      }
    }else{
      toast.error(`${_t(t("Please select from date, to date & account"))}`,common_toast);
    }
  }

  let balance = 0;
  let view_summary_balance = 0;
  let summary_balance = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Accounts Ledger Report"))}</title>
      </Helmet>

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Accounts Ledger Report"
        sheet="sheet 1"
        buttonText="Report"
        ref={componentRef}
      />

      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls1"
        filename="Accounts Summary Report"
        sheet="sheet 1"
        buttonText="Report"
        ref={componentRef1}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <style type="text/css" media="print">
            {
              "\@page { size: landscape; }\
              "
            }
          </style>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {
                  reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && 
                    (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="11" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {getSystemSettings(generalSettings, "siteName")}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Accounts Ledger Report
                                        </h3>
                                          <p className="text-center">
                                            FROM&nbsp;
                                            <Moment format="LL">
                                              {reportFields.from_date}
                                            </Moment>
                                            &nbsp;TO&nbsp;
                                            <Moment format="LL">{reportFields.to_date}</Moment>
                                          </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Accounts"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Document Id"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Voucher Date"))}
                                  </th>
                                  
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Narration"))}
                                  </th>
                                  
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cheque No"))}
                                  </th>

                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cheque Date"))}
                                  </th>

                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Account Name"))}
                                  </th>

                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Debit"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Credit"))}
                                  </th>
                                  
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Balance"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {reportData &&
                                  Object.keys(reportData).map(
                                    (group_name, index) => {
                                      let debit = 0;
                                      let credit = 0;
                                      let balance = 0;
                                      
                                      return(
                                      <div key={index}>
                                        <tr>
                                          <td
                                            scope="row"
                                          >
                                            <strong>{group_name}</strong>
                                          </td>
                                        </tr>
                                        {reportData[group_name].map((item, i) => {
                                          balance += Number(item.Debit) - Number(item.Credit); 
                                          debit += Number(item.Debit);
                                          credit += Number(item.Credit);
                                          
                                          return (
                                            <tr key={i}>
                                              <td></td>
                                              <td
                                                scope="row"
                                              >
                                                {item.DocumentIdentity}
                                              </td>
                                              <td
                                                scope="row"
                                                className="xsm-text text-capitalize align-middle text-center"
                                              >
                                                {
                                                  item.VoucherDate ? (
                                                  <Moment format="DD-MM-YYYY">
                                                    {item.VoucherDate}
                                                  </Moment>
                                                  ): "-"
                                                }
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                {item.Narration}
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                {item.ChequeNo}
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                {item.ChequeDate ? (
                                                  <Moment format="DD-MM-YYYY">
                                                    {item.ChequeDate}
                                                  </Moment>
                                                ): ""}
                                              </td>

                                              <td
                                                scope="row"
                                              >
                                                {item.branch_name}
                                              </td>

                                              <td
                                                scope="row"
                                              >
                                                {item.AccountName}
                                              </td>
                                            
                                              <td
                                                scope="row"
                                              >
                                                {formatPrice(item.Debit)}
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                {formatPrice(item.Credit)}
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                {balance < 0 ? `(${formatPrice(balance * -1)})` : formatPrice(balance)}
                                              </td>
                                            </tr>
                                          );
                                        })}
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <th
                                            colSpan={2}
                                            scope="row"
                                            className="xsm-text text-capitalize align-middle text-center"
                                          >
                                            Total
                                          </th>
                                          <td
                                          scope="row"
                                          >
                                            <b>{formatPrice(debit)}</b>
                                          </td>
                                          <td
                                          scope="row"
                                          >
                                            <b>{formatPrice(credit)}</b>
                                          </td>
                                        </tr>
                                      </div>
                                    );
                                  })
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="d-none">
        <div>
          <style type="text/css" media="print">
            {
              "\@page { size: landscape; }\
              "
            }
          </style>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {ledgerSummary.data &&
                    ledgerSummary.excel === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls1"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="7" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {getSystemSettings(generalSettings, "siteName")}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Accounts Summary Report
                                        </h3>
                                          <p className="text-center">
                                            FROM&nbsp;
                                            <Moment format="LL">
                                              {reportFields.from_date}
                                            </Moment>
                                            &nbsp;TO&nbsp;
                                            <Moment format="LL">{reportFields.to_date}</Moment>
                                          </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Date"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Document No"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Account Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Debit"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Credit"))}
                                  </th>
                                  
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Balance"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {ledgerSummary.data.map((item, i) => {
                                  summary_balance += Number(item.cur_debit) - Number(item.cur_credit); 
                                  return (
                                    <tr key={i}>
                                      <td
                                        scope="row"
                                      >
                                        {item.branch_name}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.date ? (<Moment format="DD-MM-YYYY">{item.date}</Moment>) : "" }
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.document_no}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.display_name}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {formatPrice(item.cur_debit)}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {formatPrice(item.cur_credit)}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {summary_balance < 0 ? `(${formatPrice(summary_balance * -1)})` : formatPrice(summary_balance)}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <AccountsSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading}/>
                    {/* spin loading ends */}

                    <div key="fragment-3">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Ledger Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6 col-lg-7 d-flex justify-content-end align-items-center">
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <div className="d-inline mr-2 d-flex align-items-center">
                              <input
                                type="radio"
                                className="form-check-input pointer-cursor"
                                id="view_report"
                                name="view_report"
                                value="view"
                                onChange={(e) => {
                                  handleOption(e);
                                }}
                                checked={
                                  option === "view"
                                }
                              />
                              <label
                                className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                                htmlFor="view_report"
                                style={{fontSize:"16px",borderRadius:"5px"}}
                              >
                                <i class="fa fa-eye" aria-hidden="true"></i> {_t(t("View"))}
                              </label>
                            </div>
                          </div>
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="excel_report"
                              name="excel_report"
                              value="excel"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={
                                option === "excel"
                              }
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="excel_report"
                              style={{fontSize:"16px",borderRadius:"5px"}}
                            >
                              <i class="fa fa-table" aria-hidden="true"></i> {_t(t("Excel"))}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Form starts here */}
                      <div className="card mb-2 mx-1 px-2">
                        <form
                          className="row p-1 mx-0 mb-2 table-text"
                          onSubmit={handleSubmit}
                        >
                          <div className="col-12">
                            <div>                            
                              <div className="row">
                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="fromDate"
                                      className="control-label"
                                    >
                                      {_t(t("From Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={reportFields.from_date}
                                      onChange={(date) => handleFromDate(date)}
                                      peekNextMonth
                                      maxDate={new Date()}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("From Date"))}
                                      shouldCloseOnSelect={false}                                  
                                    />
                                  </div>
                                </div>

                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="toDate"
                                      className="control-label"
                                    >
                                      {_t(t("To Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={reportFields.to_date}
                                      onChange={(date) => handleToDate(date)}
                                      peekNextMonth
                                      maxDate={new Date()}
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("To Date"))}
                                      shouldCloseOnSelect={false}                                  
                                    />
                                  </div>
                                </div>

                                <div className="form-group mt-2 col-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="transaction"
                                      className="control-label"
                                    >
                                      {_t(t("Chart Of Account"))}   
                                      <span className="text-danger">*</span>                               
                                    </label>
                                  </div>
                                  <Select
                                    options={cao3Active ? cao3Active : []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.level3_name}
                                    getOptionValue={(option) => option.id}
                                    value={reportFields.account || ""}
                                    classNamePrefix="select table-text"
                                    onChange={(acc)=>handleAccount(acc)}                                
                                    placeholder={
                                      _t(t("Select account")) + ".."
                                    }
                                    styles={customStyle}
                                    required
                                  />
                                </div>

                                <div className="form-group mt-2 col-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="transaction"
                                      className="control-label"
                                    >
                                      {_t(t("Branch"))}                                  
                                    </label>
                                  </div>
                                  <Select
                                    options={branchForSearch ? branchForSearch : []}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={reportFields.branch || ""}
                                    classNamePrefix="select table-text"
                                    onChange={(branch)=>handleBranch(branch)}
                                    isClearable                                
                                    placeholder={
                                      _t(t("Select branch")) + ".."
                                    }
                                    styles={customStyle}
                                  />
                                </div>

                                <div className="col-2">
                                  <div className="mt-3">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="showWithZero"
                                      name="showWithZero"
                                      value="without_zero"
                                      checked={reportType==="without_zero"}
                                      onChange={(e) => handleReportType(e)}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="showWithZero"
                                    >
                                      {_t(t("Without Zero"))}
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="showWithZero_no"
                                      name="showWithZero"
                                      value="with_zero"
                                      checked={reportType==="with_zero"}
                                      onChange={(e) => handleReportType(e)}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="showWithZero_no"
                                    >
                                      {_t(t("With Zero"))}
                                    </label>
                                  </div>
                                </div>
                              

                                <div className="col-6"></div>

                                <div className="d-flex align-items-center justify-content-end col-4">
                                  <div className="mr-3 mt-1">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="detail"
                                      name="detail"
                                      value="detail"
                                      onChange={(e) => {
                                        handleReportOption(e);
                                      }}
                                      checked={
                                        reportOption === "detail"
                                      }
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2 font-weight-md"
                                      htmlFor="detail"
                                    >
                                      {_t(t("Detail Report"))}
                                    </label>
                                  </div>
                                  <div className="mr-1 mt-1">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="summary"
                                      name="summary"
                                      value="summary"
                                      onChange={(e) => {
                                        handleReportOption(e);
                                      }}
                                      checked={
                                        reportOption === "summary"
                                      }
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2 font-weight-md"
                                      htmlFor="summary"
                                    >
                                      {_t(t("Summary Report"))}
                                    </label>
                                  </div>
                                </div>

                                <div style={{textAlign:"right"}} className="form-group mt-2 col-2">                                                                                                                        
                                  <button
                                  disabled={loading}
                                  type="submit"
                                  className="btn btn-primary rounded mt-2"
                                  >
                                    {_t(t("Print Ledger"))}
                                  </button>                                                                                                                                                                                       
                                </div>
                              </div>
                            </div>                                                                        
                          </div>
                        </form>

                        {/*view summary report */}
                        {
                          ledgerSummary.data && ledgerSummary.excel === false && (
                            <div className="row m-0 my-2">
                              <div className="row gx-2 justify-content-center py-2 report border border-1 rounded-sm">
                                <div className="col-12 t-mb-15 mb-md-0 bill_modal_scroll" style={{height: "calc(100vh - 23.2rem)"}}>
                                  <table
                                    className="table table-bordered my-1"
                                    id="table-to-xls"
                                  >
                                    <thead className="align-middle sm-text">
                                      <tr style={{position: "sticky", top: "-0.1px", backgroundColor: "white"}}> 
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                          style={{width:"17%"}}
                                        >
                                          {_t(t("Branch"))}
                                        </th>                                                                             
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                          style={{width:"10%"}}
                                        >
                                          {_t(t("Date"))}
                                        </th>
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                          style={{width:"15%"}}
                                        >
                                          {_t(t("Document No."))}
                                        </th>
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                          style={{width:"17%"}}
                                        >
                                          {_t(t("Account Name"))}
                                        </th>

                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Debit"))}
                                        </th>
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Credit"))}
                                        </th>
                                        
                                        <th
                                          scope="col"
                                          className="text-capitalize align-middle text-center border-1 border"
                                        >
                                          {_t(t("Balance"))}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="align-middle sm-text">
                                      {/* loop here*/}
                                      {ledgerSummary?.data && (
                                          ledgerSummary.data?.length ? (ledgerSummary?.data.map((item, index) => {
                                            view_summary_balance += Number(item.cur_debit) - Number(item.cur_credit); 
                                            return (
                                              <tr key={index}>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.branch_name}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item.date ? (<Moment format="DD-MM-YYYY">{item.date}</Moment>) : "" }
                                                </td>
                                                <td
                                                  scope="row"
                                                >
                                                  {item.document_no}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {item.display_name}
                                                </td>
                                              
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {formatPrice(item.cur_debit)}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {formatPrice(item.cur_credit)}
                                                </td>
                                                <td
                                                  scope="row"
                                                  className="text-capitalize align-middle text-center"
                                                >
                                                  {view_summary_balance < 0 ? `(${formatPrice(view_summary_balance * -1)})` : formatPrice(view_summary_balance)}
                                                </td>
                                              </tr>
                                            );
                                          })) : <tr> <td className="text-capitalize align-middle text-center" colSpan="8">No Data</td></tr>
                                        )
                                      }
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          )
                        }

                        {/* view report */}
                        {
                          (ledgerView?.data) || (searchLedgerView && searchLedgerView?.list?.length) ? (
                            <div className="row">
                              <div className="col-12">
                                <div className="d-flex justify-content-end mb-1">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 table-text rounded-sm py-1"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                    />
                                  </div>
                                </div>
                                <div className="row gx-2 justify-content-center py-2 report border border-1 rounded-sm">
                                  <div className="col-12 bill_modal_scroll" style={{height: "calc(100vh - 27.1rem)"}}>
                                    <table
                                      className="table table-bordered my-1"
                                      id="table-to-xls"
                                    >
                                      <thead className="align-middle sm-text">
                                        <tr style={{position: "sticky", top: "-0.1px", backgroundColor: "white"}}>
                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("S.No"))}
                                          </th>
                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Document Id"))}
                                          </th>
                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Voucher Date"))}
                                          </th>

                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Branch"))}
                                          </th>

                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Narration"))}
                                          </th>
                                                                                
                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Account Name"))}
                                          </th>

                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Debit"))}
                                          </th>
                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Credit"))}
                                          </th>
                                          
                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Balance"))}
                                          </th>
                                          
                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Cheque No"))}
                                          </th>

                                          <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-1 border"
                                          >
                                            {_t(t("Cheque Date"))}
                                          </th>

                                        </tr>
                                      </thead>
                                      <tbody className="align-middle sm-text">
                                        {/* loop here*/}
                                        {ledgerView?.data && !searchLedgerView.searched ? (
                                            ledgerView.data?.length ? (ledgerView?.data.map((item, index) => {
                                              balance += Number(item.Debit) - Number(item.Credit); 
                                              return (
                                                <tr key={index}>
                                                  <th
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {index +
                                                      1 +
                                                      (ledgerView.current_page -
                                                        1) *
                                                        ledgerView.per_page}
                                                  </th>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center "
                                                  >
                                                    {item.DocumentIdentity}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {
                                                      item.VoucherDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.VoucherDate}
                                                      </Moment>
                                                      ): "-"
                                                    }
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.branch_name}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.Narration}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.AccountName}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.Debit)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.Credit)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {balance < 0 ? `(${formatPrice(balance * -1)})` : formatPrice(balance)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.ChequeNo}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.ChequeDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.ChequeDate}
                                                      </Moment>
                                                    ): ""}
                                                  </td>
                                                </tr>
                                              );
                                            })) : <tr> <td className="text-capitalize align-middle text-center" colSpan="8">No Data</td></tr>
                                          )
                                          : (searchLedgerView.list && searchLedgerView.list?.length ?
                                            searchLedgerView.list.map((item, index) => { 
                                              balance += Number(item.Debit) - Number(item.Credit);                                                  
                                              return (
                                                <tr key={index}>
                                                  <th
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {index +
                                                      1 +
                                                      (ledgerView.current_page -
                                                        1) *
                                                        ledgerView.per_page}
                                                  </th>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center "
                                                  >
                                                    {item.DocumentIdentity}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {
                                                      item.VoucherDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.VoucherDate}
                                                      </Moment>
                                                      ): "-"
                                                    }
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.branch_name}
                                                  </td> 
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.Narration}
                                                  </td>                                               
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.AccountName}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.Debit)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {formatPrice(item.Credit)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {balance < 0 ? `(${formatPrice(balance * -1)})` : formatPrice(balance)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.ChequeNo}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="text-capitalize align-middle text-center"
                                                  >
                                                    {item.ChequeDate ? (
                                                      <Moment format="DD-MM-YYYY">
                                                        {item.ChequeDate}
                                                      </Moment>
                                                    ): ""}
                                                  </td>
                                                </tr>
                                              );
                                            }) : <tr> <td className="text-capitalize align-middle text-center" colSpan="8">No Data</td></tr>
                                          )
                                        }
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              {ledgerView?.data && (
                                  <>
                                    <div className= "mt-1 t-pt-5 t-pb-5">
                                      <div className="row align-items-center t-pl-15 t-pr-15">
                                        <div className="col-md-7 t-mb-15 mb-md-0">
                                          {/* pagination function */}
                                          {pagination(ledgerView, paginatedLedger)}
                                        </div>
                                        <div className="col-md-5">
                                          <ul className="t-list d-flex justify-content-md-end align-items-center">
                                            <li className="t-list__item">
                                              <span className="d-inline-block sm-text">
                                                {showingData(ledgerView)}
                                              </span>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )
                              }
                            </div>
                          ) : ""
                        }
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  )
}

export default LedgerReport;
